import React from 'react';
import classnames from 'classnames';

import { CollapsibleListSectionContent } from '../collapsible-list-section-content';
import { CollapsibleListSectionCollapsedContent } from '../collapsible-list-section-content/collapsed-content';
import { CollapsibleListSectionHeader } from '../collapsible-list-section-header';
import style from './collapsible-list-section.module.less';
import { CollapsibleListSectionSubHeader } from '../collapsible-list-section-sub-header/index';

import type { CollapsibleListSectionComponent } from './collapsible-list-section-types';

const collapsibleListSectionContentType = (
  <CollapsibleListSectionContent>
    <div />
  </CollapsibleListSectionContent>
).type;

const collapsibleListSectionCollapsedContentType = (
  <CollapsibleListSectionCollapsedContent>
    <div />
  </CollapsibleListSectionCollapsedContent>
).type;

const collapsibleListSectionHeaderType = (
  <CollapsibleListSectionHeader>
    <div />
  </CollapsibleListSectionHeader>
).type;

const collapsibleListSectionSubHeaderType = (
  <CollapsibleListSectionSubHeader>
    <div />
  </CollapsibleListSectionSubHeader>
).type;

export const CollapsibleListSection: CollapsibleListSectionComponent = ({
  children,
  open = false,
  disabled = false,
  alwaysClosed = false,
  className,
}) => {
  const headerChild = children.find((child) => child.type === collapsibleListSectionHeaderType);
  const subHeaderChild = children.find((child) => child.type === collapsibleListSectionSubHeaderType);
  const contentChild = children.find((child) => child.type === collapsibleListSectionContentType);
  const closedContentChild = children.find((child) => child.type === collapsibleListSectionCollapsedContentType);
  const classes = classnames(style['collapsible-list-section'], className);
  return (
    <div className={classes}>
      {headerChild ? React.cloneElement(headerChild, { open, disabled, alwaysClosed }) : null}
      {subHeaderChild !== undefined && React.cloneElement(subHeaderChild)}
      {open && !disabled && !alwaysClosed && contentChild ? React.cloneElement(contentChild) : null}
      {!open && closedContentChild !== undefined && React.cloneElement(closedContentChild)}
    </div>
  );
};
